module.exports = {
  painter: require('./painter')
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/g/lib/renderers/canvas/index.js
// module id = 254
// module chunks = 0 1 2